// ═══════════════════════════════════════════════════════════════════
//  modules/dashboard/utils.js
//  heatScale
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

export function heatScale(ratio) {
  if (ratio <= 0) return THEME.surface;
  const stops = [[26, 11, 46], [74, 28, 107], [181, 23, 158], [247, 37, 133], [255, 133, 0], [255, 214, 10]];
  const tt = Math.min(1, ratio) * (stops.length - 1), i = Math.floor(tt), f = tt - i;
  const a = stops[i], b = stops[Math.min(stops.length - 1, i + 1)];
  const c = a.map((v, k) => Math.round(v + (b[k] - v) * f));
  return `rgb(${c[0]},${c[1]},${c[2]})`;
}
